export enum DayType {
  NONE = 'none',
  NORMAL = 'normal',
  DISABLE = 'disable',
  ACTIVE = 'active',
}

export type DayObj = {
  date: Date;
  day: number;
  year: number;
  month: number;
  dayType: DayType;
};
